var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolNoDeletedChatList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 109,
    viewBox: "0 0 89 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0283 20.2734C19.7121 20.2734 0 39.9856 0 64.3017C0 73.3724 2.74411 81.8017 7.44593 88.8068L14.2753 96.7532C22.1112 103.941 32.5568 108.33 44.0283 108.33C68.3445 108.33 88.0566 88.6179 88.0566 64.3017C88.0566 39.9856 68.3445 20.2734 44.0283 20.2734Z",
    fill: "#2C2C7C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26747_29695",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 109
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 0 0 39.9856 0 64.3018C0 73.3725 2.74411 81.8017 7.44593 88.8069L14.2753 96.7533C22.1112 103.942 32.5568 108.33 44.0283 108.33C68.3445 108.33 88.0566 88.618 88.0566 64.3018C88.0566 53.8829 88.0566 0 88.0566 0H0Z",
    fill: "#2C2C7C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26747_29695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.339 103.905L11.627 38.4756H78.7284L74.0422 104.082C73.9974 104.709 73.7492 105.305 73.3352 105.778L71.1372 108.29C70.5891 108.916 69.7972 109.275 68.9647 109.275H23.2917C22.5846 109.275 21.9022 109.016 21.3738 108.546L18.297 105.811C17.7459 105.322 17.4032 104.639 17.339 103.905Z",
    fill: "url(#paint0_radial_26747_29695)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_i_26747_29695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0533 96.5111C44.5624 96.5582 43.3281 95.3623 43.3281 93.8706L43.3281 54.9134C43.3281 53.4325 44.5452 52.2409 46.0258 52.2722C47.4627 52.3026 48.6117 53.4761 48.6117 54.9134L48.6117 93.8706C48.6117 95.2971 47.4792 96.466 46.0533 96.5111Z",
    fill: "url(#paint1_linear_26747_29695)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_i_26747_29695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3873 96.4387C28.9022 96.593 27.6032 95.4874 27.5191 93.9973L25.3335 55.2867C25.25 53.8074 26.3972 52.5294 27.8764 52.4538C29.3123 52.3805 30.5253 53.47 30.6063 54.9059L32.7919 93.6165C32.8724 95.0418 31.8079 96.2912 30.3873 96.4387Z",
    fill: "url(#paint2_linear_26747_29695)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_i_26747_29695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5541 96.4387C63.0393 96.593 64.3382 95.4874 64.4223 93.9973L66.6079 55.2867C66.6914 53.8074 65.5442 52.5294 64.065 52.4538C62.6292 52.3805 61.4161 53.47 61.3351 54.9059L59.1495 93.6165C59.069 95.0418 60.1335 96.2912 61.5541 96.4387Z",
    fill: "url(#paint3_linear_26747_29695)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.64378 33.2513C8.54602 32.6648 8.99833 32.1309 9.59295 32.1309H80.2209C80.8201 32.1309 81.2736 32.6726 81.1682 33.2624L80.3795 37.6765C80.2975 38.1354 79.8984 38.4695 79.4323 38.4695L10.3289 38.4711C9.85852 38.4711 9.45706 38.131 9.37973 37.667L8.64378 33.2513Z",
    fill: "url(#paint4_linear_26747_29695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96194 22.1765C7.8244 21.6632 8.12903 21.1356 8.64237 20.998L77.2123 2.62476C77.7256 2.48721 78.2533 2.79185 78.3908 3.30518L78.9507 5.39453C79.0882 5.90787 78.7836 6.43552 78.2702 6.57306L9.70031 24.9463C9.18698 25.0839 8.65933 24.7792 8.52178 24.2659L7.96194 22.1765Z",
    fill: "url(#paint5_linear_26747_29695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6451 8.93333L49.5623 10.0273L48.1033 7.81748C47.875 7.47183 47.4513 7.311 47.0512 7.4182L37.1632 10.0677C36.7632 10.1749 36.4766 10.526 36.4518 10.9395L36.2931 13.5828L32.2103 14.6768L32.6527 10.9669C32.7925 9.79483 33.6318 8.82591 34.772 8.5204L48.3484 4.88263C49.4886 4.57711 50.6999 4.99656 51.407 5.94174L53.6451 8.93333Z",
    fill: "url(#paint6_linear_26747_29695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.627 38.4756H78.7284L78.5594 40.589H11.8793L11.627 38.4756Z",
    fill: "url(#paint7_linear_26747_29695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9252 13.25C83.9252 15.1277 85.5832 16.6644 87.6092 16.6644C85.5832 16.6644 83.9252 18.2011 83.9252 20.0788C83.9252 18.2011 82.2672 16.6644 80.2412 16.6644C82.2672 16.6644 83.9252 15.1277 83.9252 13.25Z",
    fill: "#18D5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9252 4.25C18.9252 6.12775 20.5832 7.66441 22.6092 7.66441C20.5832 7.66441 18.9252 9.20108 18.9252 11.0788C18.9252 9.20108 17.2672 7.66441 15.2412 7.66441C17.2672 7.66441 18.9252 6.12775 18.9252 4.25Z",
    fill: "#18D5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92518 64.25C8.92518 66.1277 10.5832 67.6644 12.6092 67.6644C10.5832 67.6644 8.92518 69.2011 8.92518 71.0788C8.92518 69.2011 7.2672 67.6644 5.24121 67.6644C7.2672 67.6644 8.92518 66.1277 8.92518 64.25Z",
    fill: "#18D5B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_26747_29695",
    x: 43.3281,
    y: 52.2715,
    width: 5.2832,
    height: 48.0898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.84906
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92453
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26747_29695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_26747_29695",
    x: 25.3291,
    y: 52.4502,
    width: 7.4668,
    height: 47.852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.84906
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92453
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26747_29695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_26747_29695",
    x: 59.1455,
    y: 52.4502,
    width: 7.4668,
    height: 47.852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.84906
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92453
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26747_29695"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_26747_29695",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4418 109.275) rotate(-87.5104) scale(60.8185 57.6414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#735FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740385,
    stopColor: "#9887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26747_29695",
    x1: 44.9132,
    y1: 97.1969,
    x2: 47.6314,
    y2: 67.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5441C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7159FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26747_29695",
    x1: 29.2884,
    y1: 97.2028,
    x2: 29.8328,
    y2: 67.2356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5441C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7159FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26747_29695",
    x1: 62.653,
    y1: 97.2028,
    x2: 62.1086,
    y2: 67.2356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5441C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7159FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26747_29695",
    x1: 45.2008,
    y1: 42.1617,
    x2: 45.2008,
    y2: 34.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5441C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710301,
    stopColor: "#907DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26747_29695",
    x1: 44.8784,
    y1: 17.9837,
    x2: 43.6467,
    y2: 13.3871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5441C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710301,
    stopColor: "#907DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26747_29695",
    x1: 43.8081,
    y1: 14.7532,
    x2: 42.2161,
    y2: 8.81172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5441C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710301,
    stopColor: "#907DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26747_29695",
    x1: 45.4418,
    y1: 38.4756,
    x2: 45.4418,
    y2: 41.1174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5441C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710301,
    stopColor: "#907DFF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolNoDeletedChatList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_no_deleted_chat_list.41d95e2d0429105d4a4d55e5e1e51391.svg";